
































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { IWitness } from "@/interfaces";
import { scammers } from "@/constants";

@Component({
  computed: {
    ...mapGetters("delegates", ["delegates"]),
    ...mapGetters("network", ["knownAccounts"]),
  },
})
export default class LinkAddress extends Vue {
  @Prop({ required: false, default: "" }) public address: string;
  @Prop({ required: false, default: "" }) public publicKey: string;
  @Prop({ required: false, default: true }) public trunc: boolean;
  @Prop({ required: false, default: "top" }) public tooltipPlacement: string;
  @Prop({ required: false, default: "" }) public containerClass: string;

  private delegate: IWitness | null | undefined = null;
  private delegates: IWitness[];
  private knownAccounts: { [key: string]: string };
 


  get isScam(): boolean {
    let test = false
    if(this.address === 'steem-supporter')
    test = true
    return test;
  }

  get isKnown(): string {
    return this.knownAccounts[this.address];
  }

  get hasDefaultSlot(): boolean {
    return !!this.$slots.default;
  }

  private getAddress(): string | boolean {
    const knownOrDelegate = this.isKnown || this.delegate;
    const truncated = !this.hasDefaultSlot && this.trunc;

    if (knownOrDelegate || truncated) {
      return this.address;
    }

    return false;
  }
}
